import { Component, OnInit, Input, Output } from '@angular/core';

import { EventEmitter } from '@angular/core';
import { StudentService } from 'src/app/services/student.service';

@Component({
  selector: 'app-textbox',
  templateUrl: './textbox.component.html',
  styleUrls: ['./textbox.component.css'],
})
export class TextboxComponent implements OnInit {
  @Input() title: string;
  @Input() type: string;
  @Input()
  valueTexbox: string;
  @Output()
  emmiterText: EventEmitter<string> = new EventEmitter<string>();
  constructor(private studentS: StudentService) {}

  ngOnInit(): void {
    this.getValue();
  }

  getValue() {
    this.emmiterText.subscribe((text) => {
      this.valueTexbox = text;
    });
  }
}
